import { Session, headerName } from "app/resources/items/session";
import { 
    keaResourceMiddleware, createBaseUrlMiddleware, createSessionMiddleware, 
    httpRequest, cacheControlMiddleware, jsonMiddleware, composeMiddlewares, rpcService, HttpRequest, statusErrorMiddleware,  
    Middleware
} 
from "kea-resource";
import { coalesce, nullsafe } from "keautils";

import  { cookies } from "kea-react";

console.log("Para forzar el redireccionamiento de la api escriba los las claves en el localStorage de 'forceRedirect': true y de 'redirectUrl': 'http://myUrl:80/' ")
const forceRedirect = cookies.Get("forceRedirect") as (boolean | null) ;
const redirectUrl = cookies.Get("redirectUrl") as (string | null);

console.log("forceRedirect: " + forceRedirect);
console.log("redirectUrl: " + redirectUrl);

const cordovaRedirect : Middleware<HttpRequest> = async (request: HttpRequest, next: (request: HttpRequest) => Promise<any> ) : Promise<any> => {
    //redireccionamiento de la URL http, se usa para que cordova pueda acceder al servidor central ya en caso de entrar con cordova las peticiones se deben
    //de dirigir a la IP publica del servidor, y no al origen actual

    

    const isCordovaApp = coalesce(forceRedirect, !!window["cordova"]) as boolean;
    if(!isCordovaApp) {
        //Si no estamos en cordova, hacemos la petición tal cual
        return await next(request);
    } 

    const redirectPrefix =  coalesce(redirectUrl,  "https://uruz.mx/");
    const url = request.url;
    const isServerRequest = /api\/.*/.test(url);

    const urlFix = redirectPrefix + url;
    const newUrl = isServerRequest ?  urlFix : url;
    const newRequest: HttpRequest = {
        ... request,
        url: newUrl
    };

    return await next(newRequest);
};

const middlewares = composeMiddlewares([
    createBaseUrlMiddleware("api/rpc"),
    createSessionMiddleware(() => nullsafe(Session.getToken(), x => x.original))  ,
    cacheControlMiddleware,
    keaResourceMiddleware,
    jsonMiddleware,
 
    async (req, next)  => {
        const ret =  await next(req);
        return ret.response;
    }, 
    cordovaRedirect,
    httpRequest
]);

/**Ejecute un request HTTP */
export const request = (x: HttpRequest) => middlewares(x, null as any);

/**Crea un servicio RPC a un controlador especificado */
export const rpcController = rpcService(request);



// WEBPACK FOOTER //
// ./app/resources/rpc.ts